<template>
    <div class="flow-step flow-step--result">
        <div class="site-row flow-step__result">
            <div class="flow-step__rooms">
                <p class="flow-step__rooms-headline" v-html="formattedRoomText"></p>
                <ul class="flow-step__rooms-list">
                    <li class="flow-step__room" v-for="room in rooms">
                        <img :src="getRoomImageUrl(room.Size)" height="103" alt="" />
                        <div class="flow-step__room-text">
                            <p><b>{{ roomsDictionary.FlowResultRoomSizeText }}</b></p>
                            <p>{{ room.Size }} m<sup>2</sup> / {{ room.Volume }} m<sup>3</sup></p>
                        </div>
                        <div class="flow-step__room-text">
                            <p><b>{{ roomsDictionary.FlowResultRoomPriceText }}</b></p>
                            <p>{{ room.ActualPrice }} kr. {{ roomsDictionary.FlowResultRoomPricePostText }}</p>
                            <p v-if="room.HasCampaign" style="font-size:12px;margin-top:8px;">
                                {{ roomsDictionary.FlowResultRoomNormalPriceText }} {{ room.Price }}
                                {{ roomsDictionary.FlowResultRoomNormalPricePostText }}</p>
                        </div>
                    </li>
                </ul>
                <p class="flow-step__rooms-disclaimer">{{ roomsDictionary.FlowResultRoomDisclaimer }}</p>
            </div>
            <Guide :headline="dictionary.FlowResultGuideText" :dictionary="dictionary" :steps="guideSteps"
                @bookLinkClick="handleGuideBookLinkClick"></Guide>
        </div>
        <flowBreadcrumbs :breadcrumbs="breadcrumbs" :currentStep="step"></flowBreadcrumbs>
        <div class="flow-step__selections">
            <div class="site-row flow-step__selections-wrap">
                <p class="flow-step__selections-headline">{{ dictionary.FlowResultText }}</p>
                <div class="flow-step__selections-summary">
                    <div class="flow__departments">
                        <DepartmentCard :department="department" :dictionary="dictionary" :noSelect="true" />
                    </div>
                    <table class="flow-step__selections-summary-list">
                        <tr>
                            <flowStepSelectionsSummaryItem :stepResult="result[0]"></flowStepSelectionsSummaryItem>
                            <flowStepSelectionsSummaryItem :stepResult="result[2]"></flowStepSelectionsSummaryItem>
                        </tr>
                        <tr>
                            <flowStepSelectionsSummaryItem :stepResult="result[1]"></flowStepSelectionsSummaryItem>
                            <flowStepSelectionsSummaryItem :stepResult="result[3]"></flowStepSelectionsSummaryItem>
                        </tr>
                    </table>
                </div>


                <nav class="flow-step__navigation">
                    <button class="flow__button" type="button"
                        v-on:click="handleResetClick">{{ dictionary.FlowResultStartOverButtonText }}</button>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import DepartmentCard from "./departmentCard.vue";
import FlowStepSelectionsSummaryItem from "./flowStepSelectionsSummaryItem.vue";
import FlowBreadcrumbs from "./flowBreadcrumbs.vue";
import Guide from './guide.vue';
import bookingQueryKeys from './../booking/bookingQueryKeys.js';
const serviceUrl = "/umbraco/api/departmentsapi/";
export default {
    name: "flowResultStep",
    components: {
        DepartmentCard,
        FlowStepSelectionsSummaryItem,
        FlowBreadcrumbs,
        Guide
    },
    data() {
        return {
            rooms: [],
            roomsDictionary: [],
            queryKeys:null
        }
    },
    mounted() {
        this.queryKeys = bookingQueryKeys;
        this.getRoom();
    },
    props: ["step", "dictionary", "department", "result", "sizeResult", "guideSteps", "breadcrumbs"],
    methods: {
        handleResetClick() {
            this.$emit('resetFlow');
        },
        getRoom() {
            const vm = this;
            vm.$emit('toggleSpinner', true);

            $.get(serviceUrl + 'GetRoomsBySizeNeed',
                {
                    departmentId: vm.department.Id,
                    size: vm.formattedResult
                },
                function (response) {
                    if (response != null) {
                        vm.rooms = response.Rooms;
                        vm.roomsDictionary = response.Dictionary
                    }
                    vm.$emit('toggleSpinner', false);

                }).fail(function (error) {
                    //vm.departments = null;
                    vm.$emit('toggleSpinner', false);
                }).always(function () {
                });
        },
        getRoomImageUrl(size) {
            let roundedSize = Math.round(parseFloat(size));
            if(roundedSize > 10) roundedSize = 10;
            return "/assets/images/rooms/" + roundedSize + 'm2.jpg';
        },
        handleGuideBookLinkClick() {
            let bookLink = `${window.location.origin}${this.department.Url}?${this.queryKeys.rooms}=${this.rooms.map(x=>x.Number).toString()}`;
            window.location.href = bookLink;
        }
    },
    computed: {
        formattedResult() {
            return Math.ceil(this.sizeResult);
        },
        formattedRoomText() {
            return this.dictionary.FlowResultRoomText.replace('{departmentAddress}', `<span style="color:#A1C611">${this.department.Address}, ${this.department.City}</span>`);
        }
    }

};
</script>
